import React, {Component} from 'react';
import Project from './Project';

class Home extends Component{
  render(){
    return(
      <div>
         <div className="twoColumn">
        <img src="./images/charles.png" alt="Charles Brandt"/>
        <p>Welcome to the home of works by Charles Brandt. I am a software developer and creative technologist interested in pushing the limits of interactive media. With my background in art and programming I love combining art with technology to create great new forms of creative expression and entertainment. This site is devoted to my experiments and research.</p><p>Visit my new blog to see projects in the making: <a href="https://makingitwithcharles.tumblr.com">https://makingitwithcharles.tumblr.com</a><br/>Visit the old blog here: <a href="http://animateinexile.blogspot.com/">http://animateinexile.blogspot.com</a></p>
        
        </div>
         <div className="twoColumn">
          <Project link="./p5/blobio.html" title="Blob.io" image="./images/blobio.png" description="In this game you consume blobs smaller than you to grow larger while avoid larger ones."/>
          <Project link="./p5/mengerSponge.html" title="Menger Sponge" image="./images/mengerSponge.jpg" description="Use your mouse to interact with a 3D rotating Menger Sponge."/>
          <Project link="./p5/fireworks.html" title="Fireworks" image="./images/fireworks.jpg" description="Click to launch a firework. Press the space bar to start a show."/>
        </div>
      </div>
    );
  }
}

export default Home;
